<template>
    <div class="sign-in-content">
        <div class="form-position-wrapper">
            <ResetPinComponent></ResetPinComponent>
        </div>
    </div>
</template>

<script>
import ResetPinComponent from '../components/ResetPinComponent/ResetPinComponent';

export default {
    name: 'ResetPin',
    components: {
        ResetPinComponent
    }
};
</script>
